var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('handbook-list',{attrs:{"title":"虫害手册","kindLabel":"虫害","api":_vm.api}})}
var staticRenderFns = []

export { render, staticRenderFns }